import { render, staticRenderFns } from "./AccountNameHistoryTable.vue?vue&type=template&id=7f8a0a97&scoped=true"
import script from "./AccountNameHistoryTable.vue?vue&type=script&lang=js"
export * from "./AccountNameHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./AccountNameHistoryTable.vue?vue&type=style&index=0&id=7f8a0a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a0a97",
  null
  
)

export default component.exports